import React, {useEffect, useState} from 'react';
import {Icon} from "antd";

function AssetCode({assetId, fetchAsset, fetchedAsset, loading}) {
  const [asset, setAsset] = useState([]);
  useEffect(() => {
    if (assetId) {
      fetchAsset(assetId);
    }
  }, [assetId, fetchAsset]);

  useEffect(() => {
    // console.log(assetId, fetchedAsset);
    setAsset([...asset, ...[fetchedAsset]]);
  }, [fetchedAsset]);

  useEffect(() => {
    // console.log(asset);
  }, [asset]);

  const ast = (asset || []).filter(a => a._id === assetId);
  // console.log(ast);
  return (
    <div>{loading ?
      <Icon type="sync" spin/> : ast && ast[0] && ast[0]['assetCode']}</div>
  );
}

export default AssetCode;
